import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {ModalComponent} from './modal/modal.component';

@Injectable()
export class ModalService {

  show$ = new Subject<ModalComponent>();
  hide$ = new Subject<ModalComponent>();
  visible$ = new BehaviorSubject(false);

  private stack: ModalComponent[] = [];

  constructor() {
    this.show$.subscribe(modal => {
      this.stack.forEach(m => m.visible$.next(false));
      this.stack.push(modal);
      this.visible$.next(true);
    });
    this.hide$.subscribe(modal => {
      this.stack = this.stack.filter(m => m !== modal);
      const lastModal = this.stack[this.stack.length - 1];
      if (lastModal) {
        lastModal.visible$.next(true);
      } else {
        this.visible$.next(false);
      }
    });
  }
}
